'use es6';

import Big from 'UIComponents/elements/Big';

/* eslint-disable-next-line react/prop-types */
import { jsx as _jsx } from "react/jsx-runtime";
const FilterEditorOperatorDescriptionGroupHeader = ({
  children
}) => /*#__PURE__*/_jsx(Big, {
  className: "p-y-2",
  tagName: "div",
  use: "help",
  children: children
});
export default FilterEditorOperatorDescriptionGroupHeader;